import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';
import { RootState } from '../types/redux/states/RootState';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
